/**
 * Hook to fetch trading fee configuration
 * Caches for 1 hour since fees rarely change
 */

import { useQuery } from "@tanstack/react-query";
import { ConfigApi, type FeesConfig } from "@nordex/core";

export function useFeesConfig() {
  return useQuery({
    queryKey: ["fees-config"],
    queryFn: () => ConfigApi.getFees(),
    staleTime: 60 * 60 * 1000, // 1 hour
    gcTime: 2 * 60 * 60 * 1000, // 2 hours (previously cacheTime)
    retry: 3,
  });
}

// Re-export the type for convenience
export type { FeesConfig };
